<template>
  <el-dialog class="pv-image-dialog" :visible.sync="data.visible" :title="title"
             width="620px"
             center>
    <div>
      <div class="pv-content">
        <img :src="data.src"/>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: '',
    data: {
      visible: false,
      src: ''
    }
  }
}
</script>

<style>
.pv-image-dialog .el-dialog {
  background: #e5e9f2;
}

.pv-image-dialog .el-dialog__header {
  padding: 0 20px 0px 20px;
  height: 50px;
  background-color: #fff;
}

.pv-image-dialog .el-dialog__title {
  color: #0C0C0C;
  line-height: 50px;
}

.pv-image-dialog .el-dialog__body {
  padding: 0;
}

.pv-image-dialog .pv-content {
  padding-top: 5px;
  width: 620px;
  min-height: 400px;
  margin-left: auto;
  margin-right: auto;
}

.pv-image-dialog .pv-content img {
  width: 620px;
  height: 450px;
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/PreviewImageDialog.vue